import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapseItem from '../../atoms/Collapse/collapse';

import CardBase from 'ui-coopeuch-cardbase';
import ButtonBase from 'ui-coopeuch-button';
// import AccordionItem from 'ui-coopeuch-accordion-item';
import { Button } from '@design-system-coopeuch/web';

import Comprobante from '../../organism/Comprobante';
import PassCoopeuch from '../../organism/PassCoopeuch';
import Mensaje from '../../atoms/CajaBloqueo';
import { Tcoo } from '../../organism/Tcoo';
import Header from '../../organism/Header';
import SinFactor from '../../atoms/SinFactores';
import SpinnerLoader from '../../atoms/SpinnerLoader';

import AlertInformativo from '../../atoms/AlertInformativos';

import errorImagen from '../../../assets/img/icon-error.svg';
import iconCelular from '../../../assets/img/icon-CeluPass.svg';

import Contenedor from './styles.js';
// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';
import ClaveDinamicaSMS from '../../organism/ClaveDinamicaSMS';
import LoadIcon from '../../../assets/img/load.svg';

// pagar = false then true, button disabled = !pagar

const AutorizacionTemplate = ({
  onSubmitHandle,
  onSubmitAuthCP,
  onSumitTcco,
  datosComprobante,
  logo,
  desafios,
  coordenadasServicio,
  setvalueCoordenadas,
  reintentarDesadioTcoo,
  tcooEstado,
  cpEstado,
  statusTime,
  loader,
  estadoSaldoDisponible,
  estadoTarjeta,
  clearIntervalCP,
  usuarioCanceloPC,
  appBloqueadaPC,
  estadoInicioPassCoopeuch,
  casoBordeState,
  onSubmitReintentarPC,
  cancelarFlujo,
  customHelper,
  values,
  disableInputs,
  pagar,
  mostrarCoordenadasSMS,
  enviarDigitosSMS,
  reintentarEnvioSMS,
  celular,
  disabledCoordenadasSMS,
  casoBordeIntentosFallidos,
  casoBordeErrorGenerico,
  mensajeErrorEnviarDigitosSMS,
  mensajeExitoEnviarDigitosSMS,
  sinFactorSet,
  inicioPassCoopeuch,
  tercerFactorDisp,
  passcoopeuchCompletado,
  tcooCompletado,
}) => {
  const [collapseItem, SetCollapseItem] = useState({
    collapseUno: false,
    collapseDos: false,
  });
  const loaderDataValidar = useSelector((store) => store.ui.loaders.loaderValidar);
  const loaderValidarTcco = useSelector((store) => store.ui.loaders.loaderValidarTcco);
  const loaderInformar = useSelector((store) => store.ui.loaders.loaderInformar);
  const loaderSesion = useSelector((store) => store.ui.loaders.loaderSesion);
  const loaderObtener = useSelector((store) => store.ui.loaders.loaderObtener);
  const loaderTercerFactorSolicitar = useSelector((store) => store.ui.loaders.loaderTercerFactorSolicitar);
  const loaderTercerFactorValidar = useSelector((store) => store.ui.loaders.loaderTercerFactorValidar);
  const storeDataValidarTcco = useSelector((store) => store.entities.validarDesafioTcooReducer);

  const { datos } = datosComprobante;
  const { codigo } = storeDataValidarTcco.response;
  const { medioPago } = datos;
  const obtenemosTcooArray = desafios ? desafios.filter((a) => a.tipo === 'TC') : '0';
  const numeroDeTarjetaTcoo = obtenemosTcooArray[0] ? obtenemosTcooArray[0].nro : '';
  const lazy = cpEstado === '' ? false : true;
  let mostrarComponentes = sinFactorSet ? true : lazy;
  let error;

  if (sinFactorSet && estadoTarjeta && estadoSaldoDisponible) error = 1;
  if (!estadoSaldoDisponible && !estadoTarjeta) error = 2;

  const openCollapse = (e) => {
    if (e === 0) {
      SetCollapseItem({
        collapseUno: true,
        collapseDos: false,
      });
    } else {
      SetCollapseItem({
        collapseUno: false,
        collapseDos: true,
      });
    }
  };

  const { collapseUno, collapseDos } = collapseItem;

  return (
    <Contenedor id="login" className="col-xs col-md-12 col-sm-12 p-0" loaderTercerFactorSolicitar={loaderTercerFactorSolicitar}>
      <Header comercioimg={logo} />
      <div className="body-webpay-coopeuch">
        {loaderDataValidar ||
        loaderValidarTcco ||
        loaderInformar ||
        loaderSesion ||
        loaderObtener ? (
          <SpinnerLoader />
        ) : (
          ''
        )}

        <div className="formulario-login-coopeuch autorizacion">
          <div className="contenedor-autorizacion">
            <CardBase title="Autorización">
              <p className="subtitulo-formulario">
                {datos.nombreSocio}, ¿Cómo quieres autorizar tu transacción?
              </p>
              <Comprobante setData={datos} />
            </CardBase>
            <section
              className={
                codigo === '11' ? 'contenedor-factores factor-error' : 'contenedor-factores'
              }
            >
              {sinFactorSet || !estadoSaldoDisponible || !estadoTarjeta ? (
                <>
                  {error === 1 && mostrarComponentes ? (
                    <SinFactor />
                  ) : (
                    <AlertInformativo
                      imagen={errorImagen}
                      saldoDisponible={estadoSaldoDisponible}
                      tarjetaEstado={estadoTarjeta}
                      tipoDePago={medioPago}
                    />
                  )}
                </>
              ) : (
                <>
                  {lazy ? (
                    <>
                      <div className="contenedor-medios-de-pago">
                        {cpEstado !== 4 && !mostrarCoordenadasSMS && (
                          <CollapseItem
                            title="PassCoopeuch"
                            isCollapsed
                            handleCuenta={openCollapse}
                            index={0}
                            esCollapsable={collapseUno}
                            appBloquedaCollapse={appBloqueadaPC}
                            cpEStadoCollapse={cpEstado}
                          >
                            {cpEstado === 2 ? (
                              <Mensaje
                                imagen={errorImagen}
                                titulo={'Tu Tarjeta de Coordenadas se encuentra bloqueada.'}
                                parrafo={'Para desbloquearla, llámanos al'}
                                finBold={'600 200 1200.'}
                                colorCaja={'#F9D4D5'}
                              />
                            ) : (
                              <PassCoopeuch
                                autorizationSubmit={onSubmitAuthCP}
                                reintentarSubmit={onSubmitReintentarPC}
                                estadoTcoo={tcooEstado}
                                usuarioCancelo={usuarioCanceloPC}
                                appBloqueada={appBloqueadaPC}
                                estadoInicioPass={inicioPassCoopeuch}
                                casobordeLet={casoBordeState}
                                passcoopeuchCompletado={passcoopeuchCompletado}
                                tercerFactorDisp={tercerFactorDisp}
                              />
                            )}
                          </CollapseItem>
                        )}
                        {tcooEstado !== 4 && !mostrarCoordenadasSMS && (
                          <CollapseItem
                            title=" Tarjeta de Coordenadas"
                            isCollapsed
                            handleCuenta={openCollapse}
                            index={1}
                            esCollapsable={collapseDos}
                            codigoCollapse={codigo}
                            tcooStadoCollapse={tcooEstado}
                          >
                            {tcooEstado === 2 ? (
                              <Mensaje
                                imagen={errorImagen}
                                titulo={'Tu Tarjeta de Coordenadas se encuentra bloqueada.'}
                                parrafo={'Para desbloquearla, llámanos al'}
                                finBold={'600 200 1200.'}
                                colorCaja={'#F9D4D5'}
                              />
                            ) : (
                              <Tcoo
                                coordenadas={coordenadasServicio}
                                setvalues={setvalueCoordenadas}
                                reintentarCoordendas={reintentarDesadioTcoo}
                                onSumitTcco={onSumitTcco}
                                estado={tcooEstado}
                                progressBar={loader}
                                tarjeta={numeroDeTarjetaTcoo}
                                customHelpers={customHelper}
                                valueCoordenadas={values}
                                statusInput={disableInputs}
                                stopTimer={pagar}
                                tcooCompletado={tcooCompletado}
                                tercerFactorDisp={tercerFactorDisp}
                              />
                            )}
                          </CollapseItem>
                        )}
                        {(loaderTercerFactorSolicitar || mostrarCoordenadasSMS) && (
                          <ClaveDinamicaSMS
                            onFinished={enviarDigitosSMS}
                            onRetry={reintentarEnvioSMS}
                            loading={(loaderTercerFactorSolicitar || loaderTercerFactorValidar)}
                            celular={celular}
                            estado={pagar}
                            casoBordeIntentosFallidos={casoBordeIntentosFallidos}
                            casoBordeErrorGenerico={casoBordeErrorGenerico}
                          />
                        )}
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </>
              )}
            </section>

            {/* si no tiene passCoopeuch  */}

            {cpEstado === 4 && estadoSaldoDisponible && estadoTarjeta && desafios && tcooEstado !== 0 && (
              <section className="addons">
                <div>
                  <img src={iconCelular} alt="obten-app" />
                </div>
                <div className="info-addons">
                  <p>Ahora también puedes autorizar estas operaciones con </p>
                  <p>PassCoopeuch de manera fácil, rápida y segura</p>
                  <span>
                    Encuéntrala en <p className="ir-store">AppStore o PlayStore</p>
                  </span>
                </div>
              </section>
            )}
          </div>

          {desafios !== '' || !estadoTarjeta ? (
            <ButtonBase type="primary" label="Pagar" onClick={onSubmitHandle} disabled={!pagar} />
          ) : (
            ''
          )}
          <Button
            color="primary"
            prefix="arrow-left"
            suffix={null}
            variant="text"
            onClick={cancelarFlujo}
          >
            Cancelar
          </Button>
        </div>
      </div>
    </Contenedor>
  );
};

export default AutorizacionTemplate;
